import { Component } from '@angular/core';
import { MaterialModule } from '@fullyops/shared/material.module';
import { I18NextCapPipe } from 'angular-i18next';

@Component({
  selector: 'fo-version-mismatch-dialog',
  imports: [MaterialModule, I18NextCapPipe],
  templateUrl: './version-mismatch-dialog.component.html',
  styleUrl: './version-mismatch-dialog.component.scss',
})
export class VersionMismatchDialogComponent {}
